"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const common_1 = require("../../common");
const HostDiscoveryService = {
    setSchedulableMasters(params, values, cluster) {
        // The backend tells us when the control to update schedulable_masters is enabled,
        if (!(0, common_1.selectMastersMustRunWorkloads)(cluster)) {
            params.schedulableMasters = values.schedulableMasters;
        }
    },
};
exports.default = HostDiscoveryService;
//# sourceMappingURL=HostDiscoveryService.js.map